import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NumberHelper } from 'app/shared/helpers/number-helper';
import { ActionConfirmationDialogComponent } from '../action-confirmation-dialog/action-confirmation-dialog.component';
import { NumberDialogBoxDataFormGroup } from './number-dialog-box-data-form-group';
import { NumberDialogBoxDataModel } from './number-dialog-box-data.model';
import { AbstractActionConfirmationDialogComponent } from '../abstract-action-confirmation-dialog/abstract-action-confirmation-dialog.component';
import { MatFormField, MatLabel, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-action-confirmation-number-dialog',
  styleUrls: ['./action-confirmation-number-dialog.component.scss'],
  templateUrl: './action-confirmation-number-dialog.component.html',
  imports: [AbstractActionConfirmationDialogComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError],
})
export class ActionConfirmationNumberDialogComponent {
  public data: NumberDialogBoxDataModel;
  public dialogRef = inject<MatDialogRef<ActionConfirmationDialogComponent>>(MatDialogRef);
  public formGroup: FormGroup<NumberDialogBoxDataFormGroup>;

  private _data = inject<NumberDialogBoxDataModel>(MAT_DIALOG_DATA);

  public constructor() {
    const _data = this._data;

    this.data = _data;
    if (!this._data.acceptLabel) {
      this.data.acceptLabel = 'Oui';
    }
    if (!this._data.declineLabel) {
      this.data.declineLabel = 'Non';
    }
    if (!this._data.numberPatternErrorLabel) {
      this.data.numberPatternErrorLabel = 'Nombre non valide';
    }
    if (!this._data.numberMatLabel) {
      this.data.numberMatLabel = 'Montant (€)';
    }
    if (!this._data.numberRequiredErrorLabel) {
      this.data.numberRequiredErrorLabel = 'Saisir le nombre';
    }
    this._createForm(_data);
  }

  public onAcceptClickedHandler(): void {
    if (this._data.onAccept) {
      this._data.onAccept(this.formGroup.controls?.numberValue?.value);
    }
    this.dialogRef.close(true);
  }

  public onDeclineClickedHandler(): void {
    if (this._data.onDecline) {
      this._data.onDecline();
    }
    this.dialogRef.close(false);
  }

  private _createForm(dialogBoxData: NumberDialogBoxDataModel): void {
    this.formGroup = new FormGroup<NumberDialogBoxDataFormGroup>({
      numberValue: new FormControl<number>(dialogBoxData.numberValue, [
        Validators.min(NumberHelper.int32MinValue),
        Validators.max(NumberHelper.int32MaxValue),
        Validators.pattern(/^[-]?\d{0,10}(\.\d{0,2})?$/),
      ]),
      numberMatLabel: new FormControl<string>(dialogBoxData.numberMatLabel!),
    });
  }
}
